exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vx-row[data-v-602c570c]{\n  -webkit-transition:all 1s;\n  transition:all 1s\n}\n.vs-slider--circles.isEndValue[data-v-602c570c]{\n  border-radius:50% !important\n}", ""]);

// exports
